import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";

const TutorialModal = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [username, setUsername] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useImperativeHandle(ref, () => ({
        open: handleShow,
        close: handleClose,
    }));

    useEffect(() => {
        const hasSeenTutorial = localStorage.getItem("hasSeenTutorial");
        const storedUsername = localStorage.getItem("username");
        if (storedUsername) {
            const formattedUsername = storedUsername.charAt(0).toUpperCase() + storedUsername.slice(1);
            setUsername(formattedUsername);
        }
        if (!hasSeenTutorial) {
            handleShow();
            localStorage.setItem("hasSeenTutorial", "true");
        }
    }, []);

    const videos = [
        {
            url: "https://www.youtube.com/embed/yxz-FTrsWzo",
            title: "Flicknexs - Frontend",
            productTypes: ["full_package"], // only for full package
        },
        {
            url: "https://www.youtube.com/embed/18aPuf0CJOk",
            title: "VOD Library - Frontend View",
            productTypes: ["video_library", "full_package"],
        },
        {
            url: "https://www.youtube.com/embed/kn0xUg14lZk",
            title: "Email Configuration",
            productTypes: ["video_library", "playout", "full_package"],
        },
        {
            url: "https://www.youtube.com/embed/kVtrHY1cX74",
            title: "Flicknexs - Playout",
            productTypes: ["playout", "full_package"],
        },
        {
            url: "https://www.youtube.com/embed/U1IpL9wc1Z8",
            title: "Flicknexs - Backend",
            productTypes: ["full_package"],
        },
    ];

    const productTypeFromEnv = process.env.REACT_APP_DEPLOYMENT_PRODUCT_TYPE;
    const productType = (props.adminSetting && (props.adminSetting.productType || props.adminSetting?.settings?.productType)) || (productTypeFromEnv && productTypeFromEnv !== "null" && productTypeFromEnv !== "undefined" ? productTypeFromEnv : "full_package");
    const normalizedProductType = (productType || "").toLowerCase();
    const filteredVideos = videos.filter((video) =>
        video.productTypes.includes(normalizedProductType || "full_package")
    );

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static" keyboard={true}>
            <Modal.Header closeButton>
                <MessageHeading text={t(`Hey ${username || "Admin"} 👋, here’s a quick walkthrough for you`)} classname="theme-text-color" noMargin border padding />
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
                <div className="row gy-4">
                    {filteredVideos.map((video, index) => (
                        <div key={index} className="col-md-4">
                            <div className="ratio ratio-16x9">
                                <iframe src={`${video.url}?rel=0`} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen style={{ borderRadius: "8px" }}></iframe>
                            </div>
                            <h6 className="mt-2 text-center text-truncate" style={{ maxWidth: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }} title={video.title}>{video.title}</h6>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
});

export default TutorialModal;
